import { Close, UploadFile } from '@mui/icons-material';
import { Box, IconButton, LinearProgress, Stack, Typography } from '@mui/material';

type TypeProps = {
  data: File;
  onDelete: (e: unknown) => void;
};

export const UploadedFile = ({ data, onDelete }: TypeProps) => {
  return (
    <Stack direction='row' mb={2} width='100%' alignItems='center' gap={2} paddingX={1.5}>
      <Box
        width={40}
        height={40}
        sx={{ padding: 1, borderRadius: '50%', background: ' #1976D21F' }}
      >
        <UploadFile color='primary' />
      </Box>
      <Stack width='100%' direction='row' alignItems='center' gap={3}>
        <Stack width='100%' direction='column'>
          <Typography lineHeight={1}>{data.name}</Typography>
          <Typography variant='subtitle1' fontSize={14} mb={1}>
            {(data.size / 1024).toFixed(2)}kb • Complete
          </Typography>
          <LinearProgress variant='determinate' value={100} color='primary' />
        </Stack>
        <IconButton onClick={onDelete}>
          <Close color='inherit' />
        </IconButton>
      </Stack>
    </Stack>
  );
};
